import { render, staticRenderFns } from "./BackTestDataTable.vue?vue&type=template&id=28081574&scoped=true&"
import script from "./BackTestDataTable.vue?vue&type=script&lang=js&"
export * from "./BackTestDataTable.vue?vue&type=script&lang=js&"
import style0 from "./BackTestDataTable.vue?vue&type=style&index=0&id=28081574&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28081574",
  null
  
)

export default component.exports